import type { StatusPresetMap } from './types'

export type Env = 'all' | 'production' | 'staging' | 'local'

export const envPresets: StatusPresetMap<Env> = {
  all: { label: 'All', tone: 'neutral' },
  production: { label: 'Production', tone: 'critical' },
  staging: { label: 'Staging', tone: 'warning' },
  local: { label: 'Local', tone: 'info' },
}
